module.exports = __webpack_public_path__ + "static/media/troms-finmark-ludovic-charlet-FyyQL69huIg-unsplash.f6d72f9a.jpg";